(() => {
  const motionSelectors = [
    '.sh-benefits__intro',
    '.sh-cards',
    '.sh-visual__copy',
    '.sh-visual__media',
    '.sh-setup .sh-label',
    '.sh-setup .sh-heading',
    '.sh-steps',
    '.sh-package__grid',
    '.sh-safety',
    '.sh-faq__heading',
    '.sh-faq__items',
    '.sh-final__panel'
  ].join(',');

  const initMotion = (scope = document) => {
    const targets = [...scope.querySelectorAll(motionSelectors)].filter((target) => !target.classList.contains('sh-reveal'));
    if (!targets.length) return;

    targets.forEach((target) => target.classList.add('sh-reveal'));
    document.documentElement.classList.add('sh-motion-ready');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    targets.forEach((target) => observer.observe(target));
  };

  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const mainImage = root.querySelector('#SolarHeartMainImage');
    const thumbs = root.querySelectorAll('[data-sh-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.imageSrc;
        mainImage.srcset = '';
        mainImage.alt = thumb.dataset.imageAlt || '';
        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });

    const variantInput = root.querySelector('[data-sh-variant-id]');
    const variantName = root.querySelector('[data-sh-selected-variant]');
    const priceNodes = document.querySelectorAll('[data-sh-price]');
    const addButton = root.querySelector('[data-sh-add]');
    const addLabel = root.querySelector('[data-sh-add-label]');

    root.querySelectorAll('[data-sh-variant]').forEach((button) => {
      button.addEventListener('click', () => {
        const available = button.dataset.available === 'true';
        root.querySelectorAll('[data-sh-variant]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (variantInput) variantInput.value = button.dataset.variantId;
        if (variantName) variantName.textContent = button.dataset.variantTitle;
        priceNodes.forEach((node) => { node.textContent = button.dataset.variantPrice; });
        if (addButton) addButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';

        const url = new URL(window.location.href);
        url.searchParams.set('variant', button.dataset.variantId);
        window.history.replaceState({}, '', url);
      });
    });
  };

  document.querySelectorAll('[data-sh-product-hero]').forEach(init);
  initMotion();
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector('[data-sh-product-hero]'));
    initMotion(event.target);
  });
})();
